import { Link } from "react-router-dom";

export function AboutPage() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero page-hero--brand">
        <div className="container">
          <span className="eyebrow">Enlightenment Through Dreams</span>
          <h1 className="display-1 page-hero__title-spaced">About Us</h1>
          <p className="body-xl text-muted" style={{ maxWidth: "680px", margin: "0 auto 2rem" }}>
            A platform whose sole mission is to
            spread mindful meditation, vegetarianism, and to make everyone aware of their
            inner self to enlighten themselves.
          </p>
          <div className="hero-actions">
            <Link to="/donate" className="btn btn--brand">Support the Mission</Link>
            <Link to="/volunteer" className="btn btn--outline">Volunteer with Us</Link>
          </div>
        </div>
      </section>

      {/* Mission statement */}
      <section className="section section--surface-alt">
        <div className="container container--narrow">
          <div className="about-mission-card">
            <div className="about-mission-card__overline">Our Mission</div>
            <blockquote className="about-mission-card__quote">
              "We are a platform whose sole mission
              is to spread mindful meditation, vegetarianism, and to make everyone aware of
              their inner self to enlighten themselves."
            </blockquote>
          </div>
        </div>
      </section>

      {/* Pillars */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">What We Stand For</span>
            <h2 className="display-3">Three Pillars of Transformation</h2>
          </div>
          <div className="grid-3" style={{ marginTop: "2.5rem" }}>
            <div className="feature-card feature-card--accent">
              <div className="feature-card__icon">🧘</div>
              <h3 className="feature-card__title">Mindful Meditation</h3>
              <p className="feature-card__body">
                Ancient practices made accessible for modern life. From breath awareness
                to deep samadhi, we guide seekers through every stage of the inward journey.
              </p>
            </div>
            <div className="feature-card feature-card--accent">
              <div className="feature-card__icon">🌱</div>
              <h3 className="feature-card__title">Vegetarianism</h3>
              <p className="feature-card__body">
                Ahimsa — non-violence — begins on the plate. We teach that a plant-based
                lifestyle supports clarity of mind, compassion for all beings, and spiritual
                progress.
              </p>
            </div>
            <div className="feature-card feature-card--accent">
              <div className="feature-card__icon">✨</div>
              <h3 className="feature-card__title">Inner Awakening</h3>
              <p className="feature-card__body">
                Beyond philosophy, we offer tools for genuine self-realization — dream
                exploration, astral awareness, and consciousness expansion through guided
                sadhana.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our story */}
      <section className="section section--surface-alt">
        <div className="container">
          <div className="about-story-split">
            <div className="about-story-content">
              <span className="eyebrow">Our Story</span>
              <h2 className="display-3">From a Dream to a Movement</h2>
              <p className="body-lg">
                Our platform began as a personal realization — that the ancient wisdom of
                India's rishis holds transformative power for every human being, regardless
                of religion, culture, or background.
              </p>
              <p className="body-md text-muted" style={{ marginTop: "1rem" }}>
                What started as small satsangs has grown into a global community of seekers
                united by a shared hunger for truth. Through events, digital tools, and
                a growing library of teachings, we strive to make the path to Aekam
                clear, practical, and available to all.
              </p>
              <div style={{ marginTop: "2rem" }}>
                <Link to="/events" className="btn btn--outline">Upcoming Events</Link>
              </div>
            </div>
            <div className="about-story-visual">
              <div className="about-story-symbol" aria-hidden="true">🕉️</div>
              <div className="about-story-tagline">Ancient Wisdom · Modern Seekers</div>
            </div>
          </div>
        </div>
      </section>

      {/* Team / Leadership (placeholder) */}
      <section className="section">
        <div className="container">
          <div className="section-header">
            <span className="eyebrow">Leadership</span>
            <h2 className="display-3">Guided by Dedicated Teachers</h2>
            <p className="text-muted body-lg" style={{ maxWidth: "560px" }}>
              Our teachers and volunteers give freely of their time to share these
              teachings with the world — in the spirit of seva (selfless service).
            </p>
          </div>
          <div className="about-team-note">
            <p className="text-muted">
              To connect with our team, reach us at{" "}
              <a href="mailto:hello@aekam.app" className="text-link">
                hello@aekam.app
              </a>{" "}
              or call{" "}
              <a href="tel:+19292665742" className="text-link">
                929-266-5742
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* CTA strip */}
      <section className="section section--cta">
        <div className="container container--narrow" style={{ textAlign: "center" }}>
          <h2 className="display-3">Join the Journey</h2>
          <p className="body-lg text-muted" style={{ margin: "1rem 0 2rem" }}>
            Whether you're a curious beginner or an advanced practitioner, there is a
            place for you in our community.
          </p>
          <div className="hero-actions" style={{ justifyContent: "center" }}>
            <Link to="/login" className="btn btn--brand">Create Free Account</Link>
            <Link to="/events" className="btn btn--outline">Attend an Event</Link>
            <Link to="/volunteer" className="btn btn--ghost">Volunteer</Link>
          </div>
        </div>
      </section>
    </>
  );
}
